module.exports = __webpack_public_path__ + "img/icon_home_active.1d6699cc.png";